









import { Component, Vue } from 'vue-property-decorator'

// Components
import Box from '@/components/common/Box.vue'

@Component({
  components: {
    Box
  }
})
export default class TrialWelcomeModal extends Vue {
}
